import { render, staticRenderFns } from "./antiMoneyLaunderingList.vue?vue&type=template&id=44b38122&scoped=true"
import script from "./antiMoneyLaunderingList.vue?vue&type=script&lang=js"
export * from "./antiMoneyLaunderingList.vue?vue&type=script&lang=js"
import style0 from "./antiMoneyLaunderingList.vue?vue&type=style&index=0&id=44b38122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b38122",
  null
  
)

export default component.exports